import { useAppSelector } from 'src/app/store/hooks';

export const isDevEnv = ['local', 'staging'].includes(
  process.env.REACT_APP_ENV || ''
);

export const isCIEnv = process.env.REACT_APP_ENV === 'ci-unit';

const BAMBI_INTERNAL_TESTING_ORGANIZATION_ID =
  '01850d81-cd16-7c07-0331-c77ba40ab2c8';

export function useIsBambiInternalTesting() {
  const currentOrganizationId = useAppSelector(
    (state) => state.auth.currentOrganizationId
  );
  return currentOrganizationId === BAMBI_INTERNAL_TESTING_ORGANIZATION_ID;
}
